import { useTranslation } from "react-i18next";
import useProjectAuthorizationReport from "./ProjectAuthorizationReportHook";
import { Col, Form, Row, Select, Spin } from "antd";
import { Button, LayoutCell, LayoutHeader, OneLineText, StandardTable } from "react3l-ui-library";
import { Send16, View16 } from "@carbon/icons-react";
import React, { useMemo, useState } from "react";
import { projectAuthorizationReportRepository } from "repositories/project-authorization-report-repository";
import { getFileUtf8FromBlob } from "helpers/utils";
import { ProjectParticipant } from "models/ProjectParticipant";
import { ColumnProps } from "antd/lib/table";
import { Moment } from "moment";
import { formatDateTime } from "helpers/date-time";

const ProjectAuthorizationReportView = () => {

    const [form] = Form.useForm();
    const [translate] = useTranslation();
    const debounceTimer = React.useRef<number | null>(null);
    const [listDataReport, setListDataReport] = useState<any>();
    const [loading, setLoading] = useState<boolean>(false);

    const {
        projects,
        organizations,
        appUsers,
        sites,
        filterProject,
        filterOrganization,
        filterAppUser,
        filterSite,
    } = useProjectAuthorizationReport();

    const handleSearchProject = React.useCallback(
        (value: any) => {
            // Hủy bỏ bất kỳ time-out nào đã được đặt trước đó
            if (debounceTimer.current) {
                clearTimeout(debounceTimer.current);
            }

            // Đặt một time-out mới để gọi API sau một khoảng thời gian
            // @ts-ignore
            debounceTimer.current = setTimeout(() => {
                // const formValue = form.getFieldsValue();
                filterProject({
                    search: value ? value : null,
                });
            }, 300);
        },
        [filterProject]
    );

    const handleChangeProject = React.useCallback(
        (value: any) => {
            // Hủy bỏ bất kỳ time-out nào đã được đặt trước đó
            if (debounceTimer.current) {
                clearTimeout(debounceTimer.current);
            }

            // Đặt một time-out mới để gọi API sau một khoảng thời gian
            // @ts-ignore
            debounceTimer.current = setTimeout(() => {
                // const formValue = form.getFieldsValue();
                filterProject({});
            }, 300);
        },
        [filterProject]
    );

    const handleSearchOrganization = React.useCallback(
        (value: any) => {
            // Hủy bỏ bất kỳ time-out nào đã được đặt trước đó
            if (debounceTimer.current) {
                clearTimeout(debounceTimer.current);
            }

            // Đặt một time-out mới để gọi API sau một khoảng thời gian
            // @ts-ignore
            debounceTimer.current = setTimeout(() => {
                // const formValue = form.getFieldsValue();
                filterOrganization({
                    search: value ? value : null,
                });
            }, 300);
        },
        [filterOrganization]
    );

    const handleChangeOrganization = React.useCallback(
        (value: any) => {
            // Hủy bỏ bất kỳ time-out nào đã được đặt trước đó
            if (debounceTimer.current) {
                clearTimeout(debounceTimer.current);
            }

            // Đặt một time-out mới để gọi API sau một khoảng thời gian
            // @ts-ignore
            debounceTimer.current = setTimeout(() => {
                // const formValue = form.getFieldsValue();
                filterOrganization({});
            }, 300);
        },
        [filterOrganization]
    );

    const handleSearchAppUser = React.useCallback(
        (value: any) => {
            // Hủy bỏ bất kỳ time-out nào đã được đặt trước đó
            if (debounceTimer.current) {
                clearTimeout(debounceTimer.current);
            }

            // Đặt một time-out mới để gọi API sau một khoảng thời gian
            // @ts-ignore
            debounceTimer.current = setTimeout(() => {
                // const formValue = form.getFieldsValue();
                filterAppUser({
                    search: value ? value : null,
                });
            }, 300);
        },
        [filterAppUser]
    );

    const handleChangeAppUser = React.useCallback(
        (value: any) => {
            // Hủy bỏ bất kỳ time-out nào đã được đặt trước đó
            if (debounceTimer.current) {
                clearTimeout(debounceTimer.current);
            }

            // Đặt một time-out mới để gọi API sau một khoảng thời gian
            // @ts-ignore
            debounceTimer.current = setTimeout(() => {
                // const formValue = form.getFieldsValue();
                filterAppUser({});
            }, 300);
        },
        [filterAppUser]
    );

    const handleSearchSite = React.useCallback(
        (value: any) => {
            if (debounceTimer.current) {
                clearTimeout(debounceTimer.current);
            }

            // @ts-ignore
            debounceTimer.current = setTimeout(() => {
                filterSite({
                    search: value ? value : null,
                });
            }, 300);
        },
        [filterSite]
    );

    const handleChangeSite = React.useCallback(
        (value: any) => {
            if (debounceTimer.current) {
                clearTimeout(debounceTimer.current);
            }

            // @ts-ignore
            debounceTimer.current = setTimeout(() => {
                filterSite({});
            }, 300);
        },
        [filterSite]
    );

    const previewReport = React.useCallback(() => {
        const formValue = form.getFieldsValue();
        setLoading(true);

        projectAuthorizationReportRepository
            .list({
                projectId: (formValue?.projectId && formValue?.projectId.length > 0) ? { in: formValue.projectId } : {},
                siteId: (formValue?.siteId && formValue?.siteId.length > 0) ? { in: formValue.siteId } : {},
                organizationId: (formValue?.organizationId && formValue?.organizationId.length > 0) ? { in: formValue.organizationId } : {},
                appUserId: (formValue?.appUserId && formValue?.appUserId.length > 0) ? { in: formValue.appUserId } : {},
            })
            .subscribe({
                next: (response) => {
                    setListDataReport(response);
                    setLoading(false);
                },
                error: () => {
                    setLoading(false);
                },
            });
    },
        [form]
    );

    const exportReport = React.useCallback(() => {
        const formValue = form.getFieldsValue();
        setLoading(true);

        projectAuthorizationReportRepository
            .export({
                projectId: (formValue?.projectId && formValue?.projectId.length > 0) ? { in: formValue.projectId } : {},
                siteId: (formValue?.siteId && formValue?.siteId.length > 0) ? { in: formValue.siteId } : {},
                organizationId: (formValue?.organizationId && formValue?.organizationId.length > 0) ? { in: formValue.organizationId } : {},
                appUserId: (formValue?.appUserId && formValue?.appUserId.length > 0) ? { in: formValue.appUserId } : {},
            })
            .subscribe({
                next: (response) => {
                    getFileUtf8FromBlob(response);
                    setLoading(false);
                },
                error: () => {
                    setLoading(false);
                },
            });

    },
        [form]
    );

    const columns: ColumnProps<ProjectParticipant>[] = useMemo(
        () => [
            {
                title: () => {
                    return (
                        <LayoutHeader
                            orderType="left"
                            title={translate(
                                "projectAuthorizationReport.projectCode"
                            )}
                        />
                    );
                },
                width: 50,
                fixed: true,
                key: "project.code",
                dataIndex: "project",
                ellipsis: true,
                render(...params: [string, ProjectParticipant, number]) {
                    return (
                        <LayoutCell
                            orderType="left"
                            tableSize="md"
                        >
                            <OneLineText value={params[1]?.project?.code} countCharacters={1000} />
                        </LayoutCell>
                    );
                },
            },

            {
                title: () => {
                    return (
                        <LayoutHeader
                            orderType="left"
                            title={translate(
                                "projectAuthorizationReport.projectName"
                            )}
                        />
                    );
                },
                width: 100,
                fixed: true,
                key: "project.name",
                dataIndex: "project",
                ellipsis: true,
                render(...params: [string, ProjectParticipant, number]) {
                    return (
                        <LayoutCell
                            orderType="left"
                            tableSize="md"
                        >
                            <OneLineText value={params[1]?.project?.name} countCharacters={1000} />
                        </LayoutCell>
                    );
                },
            },

            {
                title: () => {
                    return (
                        <LayoutHeader
                            orderType="left"
                            title={"Phân hệ"}
                        />
                    );
                },
                width: 100,
                fixed: true,
                key: "site.name",
                dataIndex: "site",
                ellipsis: true,
                render(...params: [string, ProjectParticipant, number]) {
                    return (
                        <LayoutCell
                            orderType="left"
                            tableSize="md"
                        >
                            <OneLineText value={params[1]?.site?.name} countCharacters={1000} />
                        </LayoutCell>
                    );
                },
            },

            {
                title: () => {
                    return (
                        <LayoutHeader
                            orderType="left"
                            title={translate(
                                "projectAuthorizationReport.appUserCode"
                            )}
                        />
                    );
                },
                width: 60,
                fixed: true,
                key: "appUser.code",
                dataIndex: "appUser",
                ellipsis: true,
                render(...params: [string, ProjectParticipant, number]) {
                    return (
                        <LayoutCell
                            orderType="left"
                            tableSize="md"
                        >
                            <OneLineText value={params[1]?.appUser?.code} countCharacters={1000} />
                        </LayoutCell>
                    );
                },
            },

            {
                title: () => {
                    return (
                        <LayoutHeader
                            orderType="left"
                            title={translate(
                                "projectAuthorizationReport.appUserName"
                            )}
                        />
                    );
                },
                width: 80,
                fixed: true,
                key: "appUser.displayName",
                dataIndex: "appUser",
                ellipsis: true,
                render(...params: [string, ProjectParticipant, number]) {
                    return (
                        <LayoutCell
                            orderType="left"
                            tableSize="md"
                        >
                            <OneLineText value={params[1]?.appUser?.displayName} countCharacters={1000} />
                        </LayoutCell>
                    );
                },
            },

            {
                title: () => {
                    return (
                        <LayoutHeader
                            orderType="left"
                            title={translate(
                                "projectAuthorizationReport.responesibility"
                            )}
                        />
                    );
                },
                width: 100,
                fixed: true,
                key: "responsibilitiesString",
                dataIndex: "responsibilitiesString",
                ellipsis: true,
                render(...params: [string, ProjectParticipant, number]) {
                    return (
                        <LayoutCell
                            orderType="left"
                            tableSize="md"
                        >
                            <OneLineText value={params[1]?.responsibilitiesString} countCharacters={1000} />
                        </LayoutCell>
                    );
                },
            },

            {
                title: () => {
                    return (
                        <LayoutHeader
                            orderType="left"
                            title={translate(
                                "projectAuthorizationReport.organization"
                            )}
                        />
                    );
                },
                width: 100,
                fixed: true,
                key: "appUser.organization.code",
                dataIndex: "appUser",
                ellipsis: true,
                render(...params: [string, ProjectParticipant, number]) {
                    return (
                        <LayoutCell
                            orderType="left"
                            tableSize="md"
                        >
                            <OneLineText value={`${params[1]?.appUser?.organization?.code} - ${params[1]?.appUser?.organization?.name}`} countCharacters={1000} />
                        </LayoutCell>
                    );
                },
            },

            {
                title: () => {
                    return (
                        <LayoutHeader
                            orderType="left"
                            title={translate(
                                "projectAuthorizationReport.createdAt"
                            )}
                        />
                    );
                },
                width: 60,
                fixed: true,
                key: "createdAt",
                dataIndex: "createdAt",
                ellipsis: true,
                render(...params: [Moment, ProjectParticipant, number]) {
                    return (
                        <LayoutCell
                            orderType="left"
                            tableSize="md"
                        >
                            <OneLineText value={formatDateTime(params[0])} countCharacters={1000} />
                        </LayoutCell>
                    );
                },
            },

            {
                title: () => {
                    return (
                        <LayoutHeader
                            orderType="left"
                            title={translate(
                                "projectAuthorizationReport.creator"
                            )}
                        />
                    );
                },
                width: 100,
                fixed: true,
                key: "creator",
                dataIndex: "creator",
                ellipsis: true,
                render(...params: [string, ProjectParticipant, number]) {
                    return (
                        <LayoutCell
                            orderType="left"
                            tableSize="md"
                        >
                            <OneLineText value={params[1]?.creator?.displayName} countCharacters={1000} />
                        </LayoutCell>
                    );
                },
            },

            {
                title: () => {
                    return (
                        <LayoutHeader
                            orderType="left"
                            title={translate(
                                "projectAuthorizationReport.updatedAt"
                            )}
                        />
                    );
                },
                width: 60,
                fixed: true,
                key: "updatedAt",
                dataIndex: "updatedAt",
                ellipsis: true,
                render(...params: [Moment, ProjectParticipant, number]) {
                    return (
                        <LayoutCell
                            orderType="left"
                            tableSize="md"
                        >
                            <OneLineText value={formatDateTime(params[0])} countCharacters={1000} />
                        </LayoutCell>
                    );
                },
            },

            {
                title: () => {
                    return (
                        <LayoutHeader
                            orderType="left"
                            title={translate(
                                "projectAuthorizationReport.editor"
                            )}
                        />
                    );
                },
                width: 100,
                fixed: true,
                key: "updater",
                dataIndex: "updater",
                ellipsis: true,
                render(...params: [string, ProjectParticipant, number]) {
                    return (
                        <LayoutCell
                            orderType="left"
                            tableSize="md"
                        >
                            <OneLineText value={params[1]?.updater?.displayName} countCharacters={1000} />
                        </LayoutCell>
                    );
                },
            },

        ],
        [translate]
    );

    return (
        <Spin spinning={loading}>
            <div className="page-content page-content-dxg" id="page-content-dxg-id">
                <div className="info-component ml-3 mb-3">
                    <span className="info-primary">
                        {translate("projectAuthorizationReport.report")}
                    </span>
                </div>

                <div className="page page-master">
                    <div className="page-master__content mb-3">
                        <div className="pt-3 mb-3 ml-3">
                            <h5 className="font-bold">
                                {translate("projectAuthorizationReport.title")}
                            </h5>
                        </div>
                        <div className="page-master__tag-filter px-3">
                            <Form
                                form={form}
                                layout="vertical"
                            >
                                <Row
                                    gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                                    className="w-100"
                                >
                                    <Col lg={6} className="m-b--sm">
                                        <Form.Item
                                            label="Phân hệ"
                                            name="siteId"
                                        >
                                            <Select
                                                mode="multiple"
                                                maxTagCount={1}
                                                allowClear={true}
                                                showSearch
                                                size={"large"}
                                                className={"w-100"}
                                                placeholder="Chọn Phân hệ"
                                                onSearch={handleSearchSite}
                                                onChange={handleChangeSite}
                                                filterOption={false}
                                                options={sites}
                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col lg={6} className="m-b--sm">
                                        <Form.Item
                                            // rules={[
                                            //     {
                                            //         required: true,
                                            //         message: "Chưa chọn dự án",
                                            //     },
                                            // ]}
                                            label="Dự án"
                                            name="projectId"
                                        >
                                            <Select
                                                mode="multiple"
                                                maxTagCount={1}
                                                allowClear={true}
                                                showSearch
                                                size={"large"}
                                                className={"w-100"}
                                                placeholder="Chọn Dự án"
                                                onSearch={handleSearchProject}
                                                onChange={handleChangeProject}
                                                filterOption={false}
                                                options={projects}
                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col lg={6} className="m-b--sm">
                                        <Form.Item
                                            label="Công ty"
                                            name="organizationId"
                                        >
                                            <Select
                                                mode="multiple"
                                                maxTagCount={1}
                                                allowClear={true}
                                                showSearch
                                                size={"large"}
                                                className={"w-100"}
                                                placeholder="Chọn Công ty"
                                                onSearch={handleSearchOrganization}
                                                onChange={handleChangeOrganization}
                                                filterOption={false}
                                                options={organizations}
                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col lg={6} className="m-b--sm">
                                        <Form.Item
                                            label="Tài khoản"
                                            name="appUserId"
                                        >
                                            <Select
                                                mode="multiple"
                                                maxTagCount={1}
                                                allowClear={true}
                                                showSearch
                                                size={"large"}
                                                className={"w-100"}
                                                placeholder="Chọn tài khoản"
                                                onSearch={handleSearchAppUser}
                                                onChange={handleChangeAppUser}
                                                filterOption={false}
                                                options={appUsers}
                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col lg={6} className="m-b--sm d-flex">
                                        <Button
                                            htmlType="submit"
                                            type="outline-primary"
                                            className="btn--lg btn-blue mt-4 ml-2"
                                            icon={<View16 />}
                                            onClick={previewReport}
                                        >
                                            Xem báo cáo
                                        </Button>
                                        <Button
                                            htmlType="submit"
                                            type="outline-primary"
                                            className="btn--lg btn-blue mt-4 ml-2"
                                            icon={<Send16 />}
                                            onClick={exportReport}
                                        >
                                            Tải báo cáo
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                        <div className="page-master__content-table">
                            <StandardTable
                                rowKey="id"
                                columns={columns}
                                dataSource={listDataReport}
                                tableSize={"md"}
                                bordered
                                className="mt-2"
                            />
                        </div>
                    </div>

                </div>
            </div>
        </Spin >
    )
}

export default ProjectAuthorizationReportView